<div class="ticket-wrapper">
  <div class="image-container">
    <img src="assets/img/velmaral-event-qr.jpg" class="ticket-image" alt="ticket-image" />

    <h4 class="name">{{ ticketDetails?.[0].participantName }}</h4>

    <p class="name mt-5">{{ ticketDetails?.[0].email }}</p>

    <!-- QR code -->
     
    <img  [src]="qrCodeImg" class="qrCode" alt="QR Code">

    <!-- Ticket Number -->
    <p class="ticket">{{ ticketDetails?.[0].groupTicketSeq }}</p>
  </div>
</div>

